(function(){
  var root=document.getElementById('sxpdp'); if(!root) return;
  var cfgEl=document.getElementById('sxpdp-cfg'); if(!cfgEl) return;
  var cfg={}; try{ cfg=JSON.parse(cfgEl.textContent); }catch(e){ return; }
  var V=cfg.variants||[], CAT=cfg.cat||'sleep', BPCT=cfg.bpct||15, CUR=cfg.cur||'USD';
  var ADDONS=cfg.addons||{}, CHIPS=cfg.chips||{};

  var D={
   amber:{name:'Amber',bul:[
     '<b>0.10%</b> transmission at 450 nm — the melanopsin peak is removed',
     '<b>0.48%</b> at 500 nm, <b>40.5%</b> at 550 nm — part of the green band preserved',
     'Luminous transmittance <b>50.5%</b> · Filter Category 1 — safe indoors and outdoors',
     'The all-day and evening lens. Wear from late afternoon onwards.',
     '<b>100%</b> UV protection (UV400) on every lens',
     'Spectrophotometer report on file for this exact lens'],
    bands:[['380–400 nm','100% of UVA and UVB blocked (UV400)'],['400–500 nm','0.10% transmission at 450 nm — blue and violet removed'],['500–550 nm','0.48% at 500 nm rising to 40.5% at 550 nm — green partly preserved'],['Above 550 nm','66.6% at 560 nm, 96.3% at 600 nm — colour stays usable'],['Measured summary','Luminous transmittance 50.5% · Filter Category 1']]},
   red:{name:'Red',bul:[
     '<b>0.00%</b> measured transmission from 380 to 560 nm — blue and green fully blocked',
     '<b>5.8%</b> at 570 nm, <b>49.7%</b> at 600 nm — only long wavelengths pass',
     'Luminous transmittance <b>14.9%</b> · Filter Category 3 — indoor use only',
     'The night lens. Put it on two to three hours before bed.',
     '<b>100%</b> UV protection (UV400) on every lens',
     'Spectrophotometer report on file for this exact lens'],
    bands:[['380–400 nm','100% of UVA and UVB blocked (UV400)'],['400–500 nm','0.00% measured transmission — blue and violet fully blocked'],['500–560 nm','0.00% to 0.29% — the green band is fully blocked'],['Above 560 nm','5.8% at 570 nm, 49.7% at 600 nm, 92.9% at 700 nm'],['Measured summary','Luminous transmittance 14.9% · Filter Category 3 · indoor only']]},
   fl41d:{name:'FL-41 Dark',bul:[
     '<b>13.8%</b> at 450 nm — the blue band is attenuated across its width',
     '<b>12.6%</b> at 520 nm — the green band is attenuated in the same pass',
     '<b>44.2%</b> at 570 nm — the rose band is deliberately preserved',
     'Luminous transmittance <b>41.1%</b> · Filter Category 2',
     '<b>100%</b> UV protection (UV400) on every lens',
     'Built for photophobia and screen-triggered migraine'],
    bands:[['380–400 nm','100% of UVA and UVB blocked (UV400)'],['400–500 nm','7.9% at 420 nm, 13.8% at 450 nm — broad blue attenuation'],['500–550 nm','12.6% at 520 nm — green attenuated alongside blue'],['Above 550 nm','44.2% at 570 nm rising to 100% above 670 nm'],['Measured summary','Luminous transmittance 41.1% · Filter Category 2']]},
   fl41l:{name:'FL-41 Light',bul:[
     'The lighter FL-41 rose tint, for all-day indoor wear',
     'Same rose-band notch as FL-41 Dark with a higher overall transmittance',
     '<b>100%</b> UV protection (UV400) on every lens',
     'Spectrophotometer report for this tint is being finalised'],
    bands:[['380–400 nm','100% of UVA and UVB blocked (UV400)'],['Measured summary','Full spectrophotometer report for this tint is being finalised and will be published here.']]},
   yellow:{name:'DayActive Yellow',bul:[
     '<b>0%</b> transmission below 400 nm — UV fully blocked',
     '<b>36.8%</b> at 450 nm — the short-wavelength screen load is cut',
     'Luminous transmittance <b>76.5%</b> · Filter Category 1 — full-day indoor clarity',
     'Colour balance on screen stays workable for design and video',
     '<b>100%</b> UV protection (UV400) on every lens'],
    bands:[['380–400 nm','0% transmission — 100% of UVA and UVB blocked'],['400–500 nm','36.8% at 450 nm — short wavelengths attenuated for screen work'],['500–550 nm','76.5% at 550 nm — working brightness retained'],['Above 550 nm','rising to 95.0% at 700 nm — colour balance preserved'],['Measured summary','Luminous transmittance 76.5% · Filter Category 1']]},
   neuro:{name:'NeuroCalm FLX+',bul:[
     'Dual-band filter — <b>8.7%</b> at 450 nm in the first attenuation band',
     'Green channel deliberately preserved — <b>23.7%</b> at 500 nm, <b>23.4%</b> at 540 nm',
     'Second attenuation band — <b>19.5%</b> at 590 nm',
     'Luminous transmittance <b>21.7%</b> · Filter Category 2',
     'Granted Patent · IN 587746',
     '<b>100%</b> UV protection (UV400) on every lens'],
    bands:[['380–400 nm','100% of UVA and UVB blocked (UV400)'],['400–500 nm','First attenuation band — 8.7% at 450 nm'],['500–550 nm','Green channel preserved — 23.7% at 500 nm, 23.4% at 540 nm'],['560–620 nm','Second attenuation band — 19.5% at 590 nm'],['Above 620 nm','Rising to 86.4% at 700 nm'],['Measured summary','Luminous transmittance 21.7% · Filter Category 2 · Granted Patent IN 587746']]},
   c560:{name:'Circadian560',bul:[
     '<b>0.08%</b> at 560 nm — effectively zero transmission below the cut',
     'Sharp cut, not a gradual roll-off — <b>5.6%</b> at 570 nm, <b>57.6%</b> at 600 nm',
     'Luminous transmittance <b>17.2%</b> · Filter Category 3 — indoor use only',
     'Granted Patent · IN 597482',
     '<b>100%</b> UV protection (UV400) on every lens'],
    bands:[['380–560 nm','0.08% at 560 nm — no measurable transmission below the cut'],['560–600 nm','Sharp transition — 5.6% at 570 nm, 57.6% at 600 nm'],['Above 600 nm','Rising to 91.1% at 700 nm'],['Measured summary','Luminous transmittance 17.2% · Filter Category 3 · Granted Patent IN 597482']]}
  };
  var FALL={sleep:'red',migraine:'fl41d',day:'yellow',neuro:'neuro',c560:'c560'};

  function tintKey(){
    var sel=selected().join(' ').toLowerCase();
    if(sel.indexOf('fl-41 dark')>=0||(sel.indexOf('dark')>=0&&CAT==='migraine')) return 'fl41d';
    if(sel.indexOf('fl-41 light')>=0||sel.indexOf('rose')>=0) return 'fl41l';
    if(sel.indexOf('amber')>=0) return 'amber';
    if(sel.indexOf('red')>=0) return 'red';
    if(sel.indexOf('yellow')>=0) return 'yellow';
    return FALL[CAT]||'red';
  }
  function selected(){
    var out=[];
    root.querySelectorAll('.sxp-pick').forEach(function(g){
      var b=g.querySelector('.sxp-o[aria-pressed="true"]');
      out.push(b?b.getAttribute('data-ov'):'');
    });
    return out;
  }
  function money(c){
    try{ return new Intl.NumberFormat(undefined,{style:'currency',currency:CUR,minimumFractionDigits:2}).format(c/100); }
    catch(e){ return '$'+(c/100).toFixed(2); }
  }

  function findVariant(){
    var sel=selected();
    for(var i=0;i<V.length;i++){
      var ok=true;
      for(var j=0;j<sel.length;j++){ if(sel[j] && V[i].options[j]!==sel[j]){ ok=false; break; } }
      if(ok) return V[i];
    }
    return null;
  }
  function markAvailability(){
    var sel=selected();
    root.querySelectorAll('.sxp-pick').forEach(function(g,gi){
      g.querySelectorAll('.sxp-o').forEach(function(b){
        var probe=sel.slice(); probe[gi]=b.getAttribute('data-ov');
        var any=false;
        for(var i=0;i<V.length;i++){
          var ok=true;
          for(var j=0;j<probe.length;j++){ if(probe[j] && V[i].options[j]!==probe[j]){ ok=false; break; } }
          if(ok && V[i].available){ any=true; break; }
        }
        b.setAttribute('data-oos', any?'0':'1');
      });
    });
  }

  var IC={
    shield:'<path d="M12 3l7 3v5.5c0 4.2-2.9 7.6-7 8.5-4.1-.9-7-4.3-7-8.5V6l7-3z"/>',
    sun:'<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M19.1 4.9l-1.4 1.4M6.3 17.7l-1.4 1.4"/>',
    eye:'<path d="M2 12s3.6-6 10-6 10 6 10 6-3.6 6-10 6-10-6-10-6z"/><circle cx="12" cy="12" r="2.6"/>',
    screen:'<rect x="3" y="4" width="18" height="12" rx="1.6"/><path d="M9 20h6M12 16v4"/>',
    sliders:'<path d="M4 8h10M18 8h2M4 16h4M12 16h8"/><circle cx="16" cy="8" r="2"/><circle cx="10" cy="16" r="2"/>',
    gem:'<path d="M6 3h12l3 6-9 12L3 9z"/><path d="M3 9h18M9 3l-3 6 6 12M15 3l3 6-6 12"/>',
    moon:'<path d="M20 14.5A8.2 8.2 0 0 1 9.5 4 8.5 8.5 0 1 0 20 14.5z"/>',
    clock:'<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.2 2"/>',
    home:'<path d="M4 10.5L12 4l8 6.5V20a1 1 0 0 1-1 1h-4v-6H9v6H5a1 1 0 0 1-1-1z"/>',
    seal:'<circle cx="12" cy="9.5" r="5.5"/><path d="M8.6 14.2L7 21l5-2.3L17 21l-1.6-6.8"/>',
    wave:'<path d="M3 14c2.5 0 2.5-6 5-6s2.5 6 5 6 2.5-6 5-6 2.5 3 3 3"/>',
    bolt:'<path d="M13 3L5 13h6l-1 8 8-10h-6z"/>'
  };
  function chipIcon(t){
    t=(t||'').toLowerCase().replace(/<[^>]*>/g,'');
    if(/patent/.test(t)) return svg(IC.seal);
    if(/acetate|ultem|titanium|handcraft|craft/.test(t)) return svg(IC.gem);
    if(/rem|sleep|melatonin|bed(?!side)/.test(t) && !/hours? before/.test(t)) return svg(IC.moon);
    if(/hour|before bed|minutes/.test(t)) return svg(IC.clock);
    if(/indoor only|indoors only/.test(t)) return svg(IC.home);
    if(/indoor|outdoor|all day|daylight|dayactive/.test(t)) return svg(IC.sun);
    if(/screen|gaming|text|monitor|computer/.test(t)) return svg(IC.screen);
    if(/eye|dry|fatigue|photophobia|glare|light sensitiv/.test(t)) return svg(IC.eye);
    if(/colour|color|contrast|balance/.test(t)) return svg(IC.sliders);
    if(/migraine|headache|attack|trigger/.test(t)) return svg(IC.bolt);
    if(/block|uv|transmission|nm |nm,|nm.|filter|band|cuts/.test(t)) return svg(IC.shield);
    return svg(IC.wave);
  }
  function svg(p){ return '<svg viewBox="0 0 24 24" aria-hidden="true">'+p+'</svg>'; }
  var CHIPKEY={amber:'amber',red:'red',fl41d:'dark',fl41l:'light',yellow:'yellow',neuro:'neuro',c560:'c560'};
  function paintLens(){
    var k=tintKey(), d=D[k]||D.red;
    var rows=(CHIPS[CHIPKEY[k]]||[]).filter(function(x){return x && x.length;});
    if(!rows.length) rows=d.bul;
    var ul=root.querySelector('#sxp-bul ul');
    if(ul) ul.innerHTML=rows.map(function(x){return '<li><span class="sxp-ic">'+chipIcon(x)+'</span><span>'+x+'</span></li>';}).join('');
    var bd=root.querySelector('#sxp-bands');
    if(bd) bd.innerHTML=d.bands.map(function(r){return '<div class="sxband-r"><b>'+r[0]+'</b><span>'+r[1]+'</span></div>';}).join('');
  }
  function paint(){
    var v=findVariant();
    var atc=root.querySelector('#sxp-atc');
    var now=root.querySelector('#sxp-now'), was=root.querySelector('#sxp-was'), off=root.querySelector('#sxp-off');
    if(v){
      root.querySelector('#sxp-vid').value=v.id;
      now.textContent=money(v.price);
      if(v.compare_at_price && v.compare_at_price>v.price){
        was.textContent=money(v.compare_at_price); was.hidden=false;
        off.textContent=Math.round((v.compare_at_price-v.price)*100/v.compare_at_price)+'% off'; off.hidden=false;
      } else { was.hidden=true; off.hidden=true; }
      atc.disabled=!v.available;
      atc.textContent=v.available?'Add to cart':'Sold out';
      var p1=root.querySelector('#sxbn-p1'); if(p1) p1.textContent=money(v.price);
      if(v.featured_image && v.featured_image.src){
        var im=root.querySelector('#sxg-img');
        if(im){ var s0=v.featured_image.src, qi=s0.indexOf('?');
          var bse=qi<0?s0:s0.slice(0,qi), qs=qi<0?'':s0.slice(qi), dt=bse.lastIndexOf('.');
          im.src=dt>0?(bse.slice(0,dt)+'_1000x'+bse.slice(dt)+qs):s0; }
      }
    } else {
      atc.disabled=true; atc.textContent='Unavailable';
    }
    markAvailability(); paintLens(); bundleState(); rxToggle();
  }

  root.querySelectorAll('.sxp-o').forEach(function(b){
    b.addEventListener('click',function(){
      var g=b.closest('.sxp-pick');
      g.querySelectorAll('.sxp-o').forEach(function(x){x.setAttribute('aria-pressed','false');});
      b.setAttribute('aria-pressed','true');
      paint();
    });
  });

  root.querySelectorAll('.sxg-th').forEach(function(b){
    b.addEventListener('click',function(){
      root.querySelectorAll('.sxg-th').forEach(function(x){x.removeAttribute('aria-current');});
      b.setAttribute('aria-current','true');
      var im=root.querySelector('#sxg-img'); if(im) im.src=b.getAttribute('data-src');
    });
  });

  root.querySelectorAll('.sxp-qty button').forEach(function(b){
    b.addEventListener('click',function(){
      var inp=root.querySelector('#sxp-qty');
      var n=parseInt(inp.value||'1',10)+parseInt(b.getAttribute('data-q'),10);
      inp.value=n<1?1:n;
    });
  });

  var bn=null;
  function bundleState(){
    var add=root.querySelector('#sxbn-add'); if(!add) return;
    add.disabled=!bn;
    var v=findVariant();
    if(bn && v){
      var tot=(v.price+bn.price);
      var net=Math.round(tot*(100-BPCT)/100);
      add.textContent='Add bundle to cart · '+money(net)+' after '+BPCT+'%';
    } else {
      add.textContent='Add bundle to cart · '+BPCT+'% off';
    }
  }
  function prettyOpt(v){
    var l=(v||'').toLowerCase();
    if(l.indexOf('zero')>=0) return 'No power';
    if(l.indexOf('prescription')>=0) return 'With my power';
    if(l.indexOf('fl-41 dark')>=0||l.indexOf('dark tint')>=0) return 'FL-41 Dark';
    if(l.indexOf('fl-41 light')>=0||l.indexOf('light tint')>=0) return 'FL-41 Light';
    if(l.indexOf('amber')>=0) return 'Amber';
    if(l.indexOf('red')>=0) return 'Red';
    if(l.indexOf('yellow')>=0) return 'Yellow';
    return v;
  }
  function optHint(v){
    var l=(v||'').toLowerCase();
    if(l.indexOf('zero')>=0) return 'Plain lenses. Anyone can wear them.';
    if(l.indexOf('prescription')>=0) return 'Cut to your prescription in our own lab.';
    if(l.indexOf('amber')>=0) return 'Wear all day, indoors and out.';
    if(l.indexOf('fl-41 dark')>=0||l.indexOf('dark tint')>=0) return 'Stronger attenuation for bright light.';
    if(l.indexOf('fl-41 light')>=0||l.indexOf('light tint')>=0) return 'Lighter rose tint for all-day indoor wear.';
    if(l.indexOf('red')>=0) return '1 to 2 hours before bed. Indoors only.';
    return '';
  }
  function uniq(a){ var o=[]; a.forEach(function(x){ if(x && o.indexOf(x)<0) o.push(x); }); return o; }

  var modal=document.getElementById('sxbn-modal');
  if(modal){
    var pick=root.querySelector('#sxbn-pick');
    var step2=modal.querySelector('#sxbn-step2'), list=modal.querySelector('#sxbn-list');
    var tabs=modal.querySelector('.sxm-tabs'), backBtn=modal.querySelector('#sxbn-back');
    var mTitle=modal.querySelector('#sxbn-title'), useBtn=modal.querySelector('#sxbn-use');
    var cur=null, sel1='', sel2='';

    function showStep(n){
      var two=(n===2);
      if(list) list.hidden=two;
      if(tabs) tabs.hidden=two;
      if(step2) step2.hidden=!two;
      if(backBtn) backBtn.hidden=!two;
      if(mTitle) mTitle.textContent=two?'Lens options':'Choose your second pair';
    }
    function openModal(){ showStep(1); modal.setAttribute('data-open','1'); }
    function closeModal(){ modal.setAttribute('data-open','0'); }

    pick.addEventListener('click',openModal);
    modal.querySelector('#sxbn-close').addEventListener('click',closeModal);
    modal.addEventListener('click',function(e){ if(e.target===modal) closeModal(); });
    if(backBtn) backBtn.addEventListener('click',function(){ showStep(1); });

    modal.querySelectorAll('.sxm-tab').forEach(function(tb){
      tb.addEventListener('click',function(){
        modal.querySelectorAll('.sxm-tab').forEach(function(x){x.setAttribute('aria-pressed','false');});
        tb.setAttribute('aria-pressed','true');
        var c=tb.getAttribute('data-cat');
        modal.querySelectorAll('.sxm-i').forEach(function(it){ it.style.display=(it.getAttribute('data-cat')===c)?'':'none'; });
      });
    });

    function parseV(s){
      return (s||'').split('|').filter(Boolean).map(function(r){
        var a=r.split('~');
        return {id:a[0], price:parseInt(a[1],10)||0, o1:a[2]||'', o2:a[3]||''};
      });
    }
    function resolveV(){
      if(!cur) return null;
      for(var i2=0;i2<cur.vs.length;i2++){
        var v=cur.vs[i2];
        if(v.o1===sel1 && (!cur.g2.length || v.o2===sel2)) return v;
      }
      return null;
    }
    function priceFor(which,val){
      for(var i2=0;i2<cur.vs.length;i2++){
        var v=cur.vs[i2];
        if(which===1 && v.o1===val && (!cur.g2.length || v.o2===sel2)) return v.price;
        if(which===2 && v.o2===val && v.o1===sel1) return v.price;
      }
      return null;
    }
    function renderOpts(){
      var box=modal.querySelector('#sxbn-s2opts'); if(!box||!cur) return;
      var html='';
      function row(which,label,vals){
        if(vals.length<2) return '';
        var s='<div class="sxm-orow"><div class="sxm-olab">'+label+'</div><div class="sxm-ogrid">';
        vals.forEach(function(val){
          var on=(which===1? val===sel1 : val===sel2);
          var pr=priceFor(which,val), h=optHint(val);
          s+='<button type="button" class="sxm-o" data-w="'+which+'" data-val="'+String(val).replace(/"/g,'&quot;')+'" aria-pressed="'+(on?'true':'false')+'">'
            +'<em>'+prettyOpt(val)+'</em>'
            +(h?'<small>'+h+'</small>':'')
            +(pr!==null?'<b>'+money(pr)+'</b>':'')+'</button>';
        });
        return s+'</div></div>';
      }
      html+=row(1, cur.o1||'Style', cur.g1);
      html+=row(2, cur.o2||'Lens', cur.g2);
      box.innerHTML=html;
      box.querySelectorAll('.sxm-o').forEach(function(b){
        b.addEventListener('click',function(){
          if(b.getAttribute('data-w')==='1') sel1=b.getAttribute('data-val'); else sel2=b.getAttribute('data-val');
          renderOpts(); updateUse();
        });
      });
    }
    function updateUse(){
      var v=resolveV();
      if(!useBtn) return;
      useBtn.disabled=!v;
      useBtn.textContent = v ? ('Use this pair · '+money(v.price)) : 'Unavailable in this combination';
    }
    function openStep2(it){
      var vs=parseV(it.getAttribute('data-v'));
      if(!vs.length) return;
      cur={el:it, title:it.getAttribute('data-title'), img:it.getAttribute('data-img'),
           o1:it.getAttribute('data-o1'), o2:it.getAttribute('data-o2'), vs:vs};
      cur.g1=uniq(vs.map(function(v){return v.o1;}));
      cur.g2=uniq(vs.map(function(v){return v.o2;}));
      sel1=cur.g1[0]||''; sel2=cur.g2[0]||'';
      var im=modal.querySelector('#sxbn-s2img'); if(im){ if(cur.img){ im.src=cur.img; im.hidden=false; } else { im.hidden=true; } }
      var nm=modal.querySelector('#sxbn-s2name'); if(nm) nm.textContent=cur.title;
      var sb=modal.querySelector('#sxbn-s2sub'); if(sb) sb.textContent='Choose the lens for your second pair';
      renderOpts(); updateUse(); showStep(2);
    }
    modal.querySelectorAll('.sxm-i').forEach(function(it){
      it.addEventListener('click',function(){ openStep2(it); });
    });
    if(useBtn) useBtn.addEventListener('click',function(){
      var v=resolveV(); if(!v||!cur) return;
      modal.querySelectorAll('.sxm-i').forEach(function(x){x.setAttribute('aria-pressed','false');});
      cur.el.setAttribute('aria-pressed','true');
      var lbl=[prettyOpt(sel1)]; if(cur.g2.length) lbl.push(prettyOpt(sel2));
      bn={id:v.id,title:cur.title,price:v.price,img:cur.img,opt:lbl.join(' · ')};
      pick.innerHTML='<span style="display:block;font-size:9.5px;letter-spacing:.12em;color:#8E99A4;text-transform:uppercase">Second pair</span>'
        +'<span style="display:block;font-size:12px;color:#101418;margin-top:3px">'+bn.title+'</span>'
        +'<span style="display:block;font-size:11px;color:#5A6470;margin-top:2px">'+bn.opt+' · '+money(bn.price)+'</span>';
      pick.style.borderStyle='solid'; pick.style.borderColor='#1F3A5F';
      closeModal(); bundleState();
    });

    var firstTab=modal.querySelector('.sxm-tab[aria-pressed="true"]'); if(firstTab) firstTab.click();
    showStep(1);

    root.querySelector('#sxbn-add').addEventListener('click',function(){
      var v=findVariant(); if(!v||!bn) return;
      var btn=this; btn.disabled=true; btn.textContent='Adding…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:1},{id:parseInt(bn.id,10),quantity:1}]})})
        .then(function(r){ return r.json(); })
        .then(function(){ window.location.href='/cart'; })
        .catch(function(){ btn.disabled=false; bundleState(); });
    });
  }

  var bnow=root.querySelector('#sxp-buynow');
  if(bnow){ bnow.addEventListener('click',function(){
    var f=root.querySelector('#sxp-form');
    if(!f) return;
    f.setAttribute('data-go','/checkout');
    if(typeof f.requestSubmit==='function'){ f.requestSubmit(); }
    else { f.dispatchEvent(new Event('submit',{cancelable:true,bubbles:true})); }
  }); }

  function rxOn(){ return selected().join(' ').toLowerCase().indexOf('prescription')>=0; }
  function rxToggle(){
    var box=root.querySelector('#sxr-box');
    if(box) box.hidden=!rxOn();
  }
  var HINTS={
    index:{ 'std':'Standard index is included with every prescription order.',
      '167':'35% thinner and lighter than standard. The upcharge is added automatically with Add to cart.',
      '174':'55% thinner — our lightest lens, recommended above about 6.00 D. The upcharge is added automatically with Add to cart.' },
    prog:{ 'none':'Choose a progressive only if your prescription has both distance and near power.',
      'pstd':'Standard progressive corridor — included with your prescription.',
      'pwide':'Wider corridor — smoother mid and near vision. The upcharge is added automatically with Add to cart.',
      'pxwide':'Our widest corridor — most natural vision at every distance. The upcharge is added automatically with Add to cart.' },
    lab:{ 'in':'Standard lenses are cut in our own laboratory and included in the price.',
      'kr':'Ultra HD clarity and premium coatings from our Korean partner laboratory. Adds 10 to 14 days to delivery.' }
  };
  root.querySelectorAll('[data-sxri]').forEach(function(sel){
    var k=sel.getAttribute('data-sxri');
    sel.addEventListener('change',function(){
      var h=root.querySelector('[data-hint="'+k+'"]');
      if(h) h.textContent=(HINTS[k]&&HINTS[k][sel.value])||'';
    });
  });
  var fileInp=root.querySelector('#sxr-file');
  if(fileInp){
    fileInp.addEventListener('change',function(){
      var t=root.querySelector('#sxr-t'), sub=root.querySelector('#sxr-s');
      if(fileInp.files && fileInp.files[0]){
        if(t) t.textContent='Prescription attached';
        if(sub) sub.textContent=fileInp.files[0].name;
      }
    });
  }
  function pickedAddons(qty){
    var out=[];
    if(!rxOn()) return out;
    root.querySelectorAll('[data-sxri]').forEach(function(sel){
      var cfg=ADDONS[sel.value];
      if(cfg && cfg.v){
        var props={};
        props[cfg.prop]=cfg.label;
        props['For frame']=(document.querySelector('#sxpdp .sxp-h1')||{textContent:''}).textContent.trim().slice(0,80);
        out.push({id:parseInt(cfg.v,10),quantity:qty,properties:props});
      }
    });
    return out;
  }
  var form=root.querySelector('#sxp-form');
  if(form){
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var go=form.getAttribute('data-go')||'/cart';
      form.removeAttribute('data-go');
      var atc=root.querySelector('#sxp-atc');
      if(atc.disabled) return;
      var qty=parseInt((root.querySelector('#sxp-qty')||{value:'1'}).value,10)||1;
      var extras=pickedAddons(qty);
      var prev=atc.textContent; atc.disabled=true; atc.textContent='Adding…';
      fetch('/cart/add.js',{method:'POST',body:new FormData(form)})
        .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function(){
          if(!extras.length) return null;
          return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:extras})});
        })
        .then(function(){ window.location.href=go; })
        .catch(function(){ atc.disabled=false; atc.textContent=prev; });
    });
  }

  paint();
})();
